import api from 'api'
import { UserEntry } from 'components/CommandPalette/CommandPalette_Utils'

type FuzzySearchUsersResponse = {
  items: UserEntry[]
}

export const fuzzySearchUsers = async (
  search: string,
  limit = 10
): Promise<UserEntry[]> => {
  const response = await api.get<FuzzySearchUsersResponse>(
    '/admin/user/fuzzy_search',
    {
      params: {
        search: search.trim(),
        limit,
      },
    }
  )

  return response.data.items
}
